import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGitBranch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.25 7a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M6.75 9.5v5M10.75 12.25h4.5a2 2 0 0 0 2-2V9.5M19.25 7a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M9.25 17a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
    />
  </svg>
);
export default SvgGitBranch;
